import React, { createContext, useState, useEffect } from 'react';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(null || localStorage.getItem("token"));
  const [refreshToken, setRefreshToken] = useState(null || localStorage.getItem("refreshToken"));
  const [userId, setUserId] = useState(localStorage.getItem("userId") || null);
  const [userInfo, setUserInfo] = useState(null);

  const login = (token, refreshToken, userId) => {
    setAuthToken(token);
    setRefreshToken(refreshToken);
    setUserId(userId);
    localStorage.setItem('token', token);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('userId', userId);
  };

  const logout = () => {
    setAuthToken(null);
    setRefreshToken(null);
    setUserId(null)
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userId');
  };

  return (
    <AuthContext.Provider value={{ authToken, refreshToken, userId, userInfo, setUserInfo, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
